import type { BaseListingEventPayload, CampaignAttribution } from './types';

import { getAdCampaignFromStorage } from '~/composables/adCampaign';
import { useVisitorIdentity } from '~/composables/visitorIdentity';
import { camelToSnakeObject } from '~~/utils';
import { v4 as uuidv4 } from 'uuid';

function readClientFields(): BaseListingEventPayload['client'] {
	if (typeof window === 'undefined') {
		return {
			viewport_width: 0,
			viewport_height: 0,
			language: '',
			timezone: '',
			referrer: ''
		};
	}

	let timezone = '';
	try {
		timezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
	} catch {
		/* some browsers throw under restricted intents — leave empty */
	}

	return {
		viewport_width: window.innerWidth,
		viewport_height: window.innerHeight,
		language: navigator.language || '',
		timezone,
		referrer: document.referrer || ''
	};
}

function readCampaignAttribution(): CampaignAttribution {
	const adCampaign = getAdCampaignFromStorage();
	if (Object.keys(adCampaign).length === 0) return {};
	return camelToSnakeObject(adCampaign) as CampaignAttribution;
}

export function buildBaseListingEventPayload(): BaseListingEventPayload {
	const { sessionId, anonymousId } = useVisitorIdentity();
	const { user } = useUserSession();

	return {
		event_id: uuidv4(),
		session_id: sessionId,
		user_id: user.value?.id ?? null,
		anonymous_id: anonymousId,
		client: readClientFields(),
		...readCampaignAttribution()
	};
}
